import { render, staticRenderFns } from "./SurgeryEdit.vue?vue&type=template&id=63bcf8e0&scoped=true&"
import script from "./SurgeryEdit.vue?vue&type=script&lang=js&"
export * from "./SurgeryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bcf8e0",
  null
  
)

export default component.exports